<div class="w-100 h-100" fxLayout="column" fxLayoutAlign.desktop="center center" fxLayoutAlign.mobile="start center">
    <div fxLayout="column" fxLayoutAlign="center center" ngClass.mobile="pt-72 mt-72">
        <ui-kit-svg class="error-logo" [name]="errorIcon"></ui-kit-svg>
        <div class="h3-semi-bold mt-32 text-center pre-line">{{ errorTitle | translate }}</div>
        @if ((errorSubtitle | translate) !== errorSubtitle) {
            <div class="t2 mt-16 pre-line text-center">
                {{ errorSubtitle | translate }}
            </div>
        }
        @if (requestId) {
            <ui-kit-error-panel/>
            <div class="t4 mt-16 c-primary-gray-600 pre-line text-center">
                {{ 'i18n_auth_appErrorErrorCode' | translate: {code: requestId} }}
                <ui-kit-svg matRipple
                            class="i-16 circle pointer ml-8"
                            name="ic_copy"
                            ngxClipboard
                            [matRippleCentered]="true"
                            [matRippleUnbounded]="true"
                            [cbContent]="requestId"/>
            </div>
        }
    </div>
</div>
